import { makeStyles } from '@mui/styles';
import { Box, Backdrop } from '@mui/material';

import { Loader } from '../loader';

const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 99999,
    width: '100%',
    height: '100%'
  }
}));

interface Props {
  loading: boolean;
}

const WithGlobalLoaderOverlay = ({ loading }: Props) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Box className={classes.container}>
        <Backdrop open={loading}>
          <Loader />
        </Backdrop>
      </Box>
    );
  }

  return null;
};

export default WithGlobalLoaderOverlay;
